import { useOn } from "@/lib/features";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/lib/content";
import { Media } from "./Media";
import { Reveal, SectionHead } from "./Reveal";

const Tile = ({ to, ...p }) => (to ? <Link to={to} {...p} /> : <div {...p} />);

export const Gallery = () => {
  const g = useContent().data.gallery;
  const odd = g.items.length % 2 === 1;
  const insp = useOn("inspiration");
  return (
    <section className="section gallery" id="gallery" data-testid="gallery-section">
      <div className="wrap">
        <SectionHead eyebrow={g.eyebrow} title={g.title} text={g.text} />
        <div className="gallery-grid">
          {g.items.map((it, i) => {
            const wide = odd && i === g.items.length - 1;
            return (
              <Reveal key={it.slug} delay={(i % 2) * 0.08} className={wide ? "g-wide" : ""}>
                <Tile to={insp ? `/inspiration/${it.slug}` : null} className="g-link" data-testid={`gallery-item-${it.slug}`}>
                  <figure>
                    <Media src={it.image} w={600} alt={it.title || ""} />
                    <figcaption>{it.caption}{insp && <ArrowUpRight size={16} className="g-arrow" />}</figcaption>
                  </figure>
                </Tile>
              </Reveal>
            );
          })}
        </div>
        <p className="photo-disclaimer" data-testid="gallery-disclaimer">{g.disclaimer}</p>
      </div>
    </section>
  );
};
